import * as navigationActions from "actions/navigation";
import * as userActions from "actions/user";
import * as commonActions from "actions/common";
import routePaths from "app/components/Router/routePaths";
import { store } from "store/index";
import axios from "axios";

export default function (error) {
  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }
  if (401 === error.response.status) {
    const responseData = error.response.data;
    let errMsg = responseData.errorList
      ? responseData.errorList[0].errorMessage
      : responseData.message
      ? responseData.message.errorMessage
      : typeof responseData === "string"
      ? responseData
      : "Something went wrong. Please try again.";
    if (errMsg && errMsg.indexOf("Invalid Token") !== -1) {
      errMsg = "You got logged out, please login again";
    }
    store.dispatch(commonActions.setBackendErrorMessage(errMsg));
    store.dispatch(userActions.logoutUser());
    navigationActions.redirect(routePaths.loginPage);
  }
  return Promise.reject(error);
}
